import { Button, Dialog, DialogContent, DialogTitle, Grid } from '@material-ui/core'
import { useState } from 'react'
import { ValidatorForm } from 'react-material-ui-form-validator'
import Buscador from '../../../actions/ui/Buscador';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import esLocale from "date-fns/locale/es";
import { IngresoAfiliadoRecupero } from '../../../actions/autorizaciones/Autorizaciones';
import { useDispatch } from 'react-redux';
import { startAlerta } from '../../../actions/ui/alertas';

export const AltaAfiliadoRecupero = (props) => {

    const { open, close } = props;

    const dispatch = useDispatch();

    const tipoBusqueda = "Todos";
    const altaBaja = "Todos";

    const [value, setValue] = useState(null);
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);

    const onSubmitHandler = () => {
        if (value !== null) {
            const data = {
                idAfiliado: value.id_afiliado,
                fechaInicio: fechaInicio,
                fechaFin: fechaFin
            }
            dispatch(IngresoAfiliadoRecupero(data))
            close();
        }
        else {
            dispatch(
                startAlerta(
                    "Debe ingresar un afiliado",
                    "success",
                    "Comando Exitoso"
                )
            );
        }
    }

    return (
        <Dialog fullWidth maxWidth="md" open={open} >
            <DialogTitle>Ingreso Afiliado</DialogTitle>
            <DialogContent>
                <ValidatorForm onSubmit={onSubmitHandler}>
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={12}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >

                            <Buscador
                                value={value}
                                variant="outlined"
                                setValue={(val) => { setValue(val) }}
                                label="Apellido y Nombre  |  CUIT  |  DNI  |  Numero Beneficiaria/o"
                                noOptionText={"No se encuentra beneficiaria/o"}
                                endpoint={(texto) =>
                                    `Afiliados/traerPorNombreoDNIoNroAfi/${texto}/${tipoBusqueda}/${altaBaja}`
                                }
                                getOptionLabel={(option) =>
                                    `${option.apellido_y_nombre} ${option.carnet} ${option.cuil} ${option.nro_doc}`
                                }
                                renderOption={(option) => (
                                    <div style={{ display: "flex", flexDirection: "column" }}>
                                        <span
                                            style={
                                                option.fecha_baja === null
                                                    ? { color: "green" }
                                                    : { color: "red" }
                                            }
                                        >
                                            {`${option.apellido_y_nombre}`}
                                        </span>
                                        <span
                                            style={{
                                                fontSize: 12,
                                            }}
                                        >
                                            {" "}
                                            {`Nro Afi:${option.carnet} - CUIL:${option.cuil}`}
                                        </span>
                                    </div>
                                )}
                            />
                        </Grid>
                        {/* <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <TextField
                                margin="normal"
                                fullWidth
                                disabled={false}
                                label="Nro. Solicitud"
                                name="idSolicitud"
                                value={idSolicitud}
                                required={true}
                                autoComplete="off"
                                onChange={(e) => setIdSolicitud(e.target.value)}
                            />
                        </Grid> */}
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Inicio"
                                    format="dd/MM/yyyy"
                                    required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={
                                        moment(fechaInicio).isValid() ? moment(fechaInicio).format() : null
                                    }
                                    onChange={(date) => {
                                        setFechaInicio(date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            style={{ alignSelf: 'center', paddingLeft: 16 }}
                        >
                            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    margin="normal"
                                    label="Fecha Fin"
                                    format="dd/MM/yyyy"
                                    // required={true}
                                    clearLabel="Limpiar"
                                    cancelLabel="Cancelar"
                                    value={
                                        moment(fechaFin).isValid() ? moment(fechaFin).format() : null
                                    }
                                    onChange={(date) => {
                                        setFechaFin(date);
                                    }}
                                    KeyboardButtonProps={{
                                        "aria-label": "change date",
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>

                    </Grid>
                    <div
                        style={{
                            marginTop: "2rem",
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                        }}
                    >
                        <Button variant="contained" color="primary" onClick={close}>
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            //disabled={props.disabled}
                            color="primary"
                        >
                            Buscar
                        </Button>
                    </div>
                </ValidatorForm>
            </DialogContent>
        </Dialog>
    )
}
